import type {PyProxy} from "pyodide/ffi";
import {TickersUniverse, TradingAlgo} from "./typesTrading";

// pyodide-globals.d.ts
import {loadPyodide as LoadPyodideFn, PyodideInterface} from "pyodide";
import {isDev} from "./navigation";

// --- Pyodide singleton, boots the shim once -----------------------------
let pyodidePromise: Promise<PyodideInterface> | null = null;

declare global {
    interface Window {
        loadPyodide: typeof LoadPyodideFn;
    }
}

export const getPyodide = async (): Promise<PyodideInterface> => {
    if (!pyodidePromise) {
        pyodidePromise = (async () => {
            const pyodide = await window.loadPyodide({
                indexURL: "https://cdn.jsdelivr.net/pyodide/v0.26.4/full/",
            });
            return pyodide;
        })();
    }
    return pyodidePromise;
};


export const getAlgoInstance = async (
    ws: WebSocket,
    sessionId: string,
    algo: TradingAlgo,
    startDate: string,
    endDate: string,
    startingCash: number,
    tickersUniverse: TickersUniverse,
): Promise<PyProxy> => {
    const key = algo.id;

    const pyodide = await getPyodide();
    pyodide.setDebug(true);


    const shimSrc = await fetch("/runtime_shim.py").then(async (r) => {
        const txt = r.text();
        console.debug("Current runtime_shim.py text", txt);
        return txt;
    });

    const moduleName = `algo-${key}`;
    let namespace = pyodide.globals.get("dict")();
    namespace.set("__name__", moduleName);
    // setup overrides:

    // Expose the JS async fetcher under a plain (dot-free) name in the SAME namespace
    // namespace.set("_js_get_price_for_ticker_on_date", async (ticker: string, purchaseDate: string) => {
    //
    //     const r = {
    //         current_date: purchaseDate,
    //         tickers: [ticker]
    //     } as ClientPricesRequest;
    //
    //     const priceRequest = {
    //         message_type: MessageType.ClientPricesRequest,
    //         session_id: sessionId,
    //         message_data: r
    //     } as unknown as StreamingData;
    //     safeSend(ws, priceRequest);
    //     const resp = await safeRecv(ws)
    //     const data = resp.message_data as ServerPriceResponse;
    //     if (data && data.ticker_prices && data.ticker_prices.length > 0) {
    //         return {ticker: data.ticker_prices[0][0], price: data.ticker_prices[0][1]};
    //     }
    //     return null;
    // });

    // Install dependencies
    await pyodide.loadPackage("micropip");
    const micropip = pyodide.pyimport("micropip");
    await micropip.install("pydantic");
    await micropip.install("numpy");
    await micropip.install("pandas");
    await micropip.install("requests");
    await micropip.install("msgpack");
    await pyodide.runPythonAsync(shimSrc + '\n'+ algo.code, { globals: namespace });

    // patch in the js call
    // await pyodide.runPythonAsync(`
    //     async def _patched_get_price(self, ticker, purchase_date):
    //         result = await _js_get_price_for_ticker_on_date(ticker, purchase_date.isoformat())
    //         if result is None:
    //             return None
    //         return float(result.price) if result.price is not None else None
    //
    //     Broker.get_price_for_ticker_on_date = _patched_get_price
    // `, { globals: namespace });
    const AlgoClass: PyProxy = namespace.get("MyTradingAlgorithm");
    const pyDateFromISOFormat = pyodide.pyimport("datetime").date.fromisoformat;
    const instance: PyProxy = AlgoClass.callKwargs(
        {
            initial_capital: startingCash,
            start_date: pyDateFromISOFormat(startDate),
            end_date: pyDateFromISOFormat(endDate),
            is_dev: isDev(),
            ticker_universe: tickersUniverse,
        }
    );
    console.debug("About to initialize algorithm");
    instance.initialize.callKwargs({});
    namespace.destroy();
    return instance;
};
